import { useMemo } from "react";
import type { Location } from "history";

import { useSelector } from "react-redux";
import { selectAccount } from "Redux/Auth/slice";
import { readObj } from "Service/storage";

import { IAccount } from "../Types/auth";
import { useNavigate } from "react-router";
import { selectDefaultRoute } from "Redux/Role/slice";

export const usePermissions = () => {
  const profile = useSelector(selectAccount);

  return useMemo<Set<string>>(
    () => new Set<string>(profile?.user_permissions || []),
    [profile]
  );
};

export const useAuthRedirect = ({ pathname }: Location) => {
  const navigate = useNavigate();
  const defaultRoute = useSelector(selectDefaultRoute);
  const profile =
    useSelector(selectAccount) || (readObj("account") as IAccount);

  const pagesWithoutAuth = [
    "/login",
    "/reset-password-email",
    "/register",
    "/healthcheck",
  ];
  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";
  if (profile == null || !profile.is_accepted_from_admin) {
    if (
      pagesWithoutAuth.includes(pathname) ||
      pathname.startsWith("/verification") ||
      pathname.startsWith("/reset-password") ||
      pathname.startsWith("/contact/setup-password")
    )
      return;

    return "/login";
  } else if (pathname === "/login") {
    if (profile.has_completed_onboarding || !profile.is_owner) {
      if (profile?.domain?.domain_status === "registered") {
        if (profile.domain.domain) {
          if (isLocalhost) {
            navigate(defaultRoute);
          } else {
            window.location.replace(
              `https://${profile.domain?.domain}.easyfleet.ai${defaultRoute}`
            );
            return;
          }
        }
        return;
      } else if (!profile.domain?.domain) {
        window.location.replace(`https://app.easyfleet.ai${defaultRoute}`);
      } else {
        return defaultRoute;
      }
    }
    return "/onboarding-form";
  }
};
